<template>
  <a-form
    :model="formState"
    name="basic"
    class="publish-form"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
    autocomplete="off"
    @finish="handleFinish"
  >
    <div class="title">
      {{ $t('fa-bu-zhi-you-yan-ping-tai') }}
      <iconpark-icon class="icon-close" name="close" @click="handleClose" />
    </div>
    <a-divider class="my-0" />
    <div class="content">
      <a-form-item
        :label="$t('zuo-pin-ming-cheng')"
        name="name"
        :rules="[
          { required: true, message: $t('qing-shu-ru-zuo-pin-ming-cheng') },
        ]"
      >
        <a-input v-model:value="formState.name" :maxlength="24" show-count />
      </a-form-item>

      <a-form-item
        :label="$t('zuo-pin-feng-mian')"
        name="cover_oss_path"
        :rules="[{ required: true }]"
      >
        <CoverEditor
          v-model:pic="formState.cover_oss_path"
          v-model:video="formState.custom_preview_video_path"
          v-model:video-range="formState.preview_video_cut_info"
          :data="data"
        />
      </a-form-item>

      <a-form-item
        :label="$t('zuo-pin-quan-xian')"
        name="copyright_limited"
        :rules="[{ required: true }]"
      >
        <a-radio-group v-model:value="formState.copyright_limited">
          <a-radio :value="'False'">{{ $t('ke-bian-ji') }}</a-radio>
          <a-radio :value="'True'">{{ $t('zhi-du') }}</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item :label="$t('zuo-pin-biao-qian')" name="tags">
        <a-tree-select
          v-model:value="formState.tags"
          mode="multiple"
          tree-checkable
          tree-node-filter-prop="label"
          :show-checked-strategy="TreeSelect.SHOW_PARENT"
          allow-clear
          style="width: 100%"
          :placeholder="
            $t(
              'kuai-lai-shi-yong-biao-qian-rang-geng-duo-ren-neng-jing-que-sou-dao-ta-ba'
            )
          "
          max-tag-count="responsive"
          :tree-data="treeData"
        />
      </a-form-item>

      <a-form-item :label="$t('zuo-pin-jie-shao')" name="message">
        <a-textarea
          v-model:value="formState.message"
          :maxlength="120"
          show-count
          :rows="3"
          :placeholder="
            $t('qing-shu-ru-dui-zuo-pin-mo-ban-de-quan-mian-miao-shu')
          "
        />
      </a-form-item>

      <a-form-item
        v-if="!isGlobalVersion()"
        :label="$t('zuo-pin-shou-quan')"
        name="grant"
        :rules="[{ required: true }]"
      >
        <div class="item-grant">
          <template v-if="scene === 'personal'">
            <Resource :src="userInfo?.profile_url" class="avatar" />
            <span class="name">{{ userInfo?.account_name }}</span>
          </template>
          <template v-if="scene === 'team'">
            <Resource :src="userInfo?.profile_url" class="avatar" />
            <span class="name">{{ userInfo?.organization_name }}</span>
          </template>
          <AuthorizationDifferences v-slot="{ show }">
            <div @click="show">
              <div
                v-if="scene === 'personal' && isRightTaste"
                class="none-grant"
              >
                {{ $t('wu-shou-quan') }}
              </div>
              <div v-else-if="scene === 'personal'" class="personal-grant">
                {{ $t('ge-ren-shang-yong-shou-quan') }}
              </div>
              <div v-if="scene === 'team'" class="team-grant">
                {{ $t('qi-ye-shang-yong-shou-quan') }}
              </div>
            </div>
          </AuthorizationDifferences>
        </div>
      </a-form-item>

      <a-form-item
        class="full-form-item"
        :wrapper-col="{ span: 24 }"
        :label-col="{ span: 0 }"
      >
        <div class="tip-title">
          {{
            $t(
              'wen-xin-ti-shi-fu-he-yi-xia-yao-qiu-de-shi-pin-hui-geng-rong-yi-bei-guan-fang-xuan-zhongo'
            )
          }}
        </div>
        <div class="tip-rules">
          <p>
            {{
              $t(
                '1-shi-pin-zhu-ti-fu-he-shi-ji-ge-ren-huo-qi-ye-de-ying-yong-chang-jing-you-ming-que-de-shi-pin-shou-zhong'
              )
            }}
          </p>
          <p>
            {{
              $t(
                '2-xuan-ze-de-ren-wu-chang-jing-gen-shi-pin-zhu-ti-qiang-xiang-guan-tian-jia-dong-zuo-he-li-jing-tou-zu-he-shun-chang-bu-tu-wu'
              )
            }}
          </p>
          <p>
            {{
              $t(
                '3-dao-ru-de-tu-pian-shi-pin-ppt-deng-su-cai-mei-guan-qing-xi-qie-wu-shui-yin-wu-ban-quan-jiu-fen-pai-lie-tuo-dang'
              )
            }}
          </p>
          <p>
            {{
              $t(
                '4-hou-qi-bao-zhuang-he-li-tie-zhi-hua-zi-yin-le-deng-su-cai-chu-xian-de-shi-ji-zhun-que-shi-jue-ting-jue-da-pei-xiang-de-yi-zhang'
              )
            }}
          </p>
        </div>
      </a-form-item>
    </div>
    <a-divider class="my-0" />
    <div class="footer">
      <a-button @click="handleClose">{{ $t('qu-xiao') }}</a-button>
      <a-button type="primary" html-type="submit" :loading="loading">
        {{ $t('ti-jiao') }}
      </a-button>
    </div>
  </a-form>
</template>

<script lang="ts" setup>
import { TreeSelect, type TreeSelectProps } from 'ant-design-vue'
import type { BaseOptionType } from 'ant-design-vue/es/vc-tree-select/TreeSelect'
import { setWith } from 'lodash-es'
import CoverEditor from './CoverEditor/index.vue'
import { usePublishSuccess } from './message'
import AuthorizationDifferences from '~/features/paymentDesk/components/buy-rights/authorization-differences.vue'

import type { Tag } from '~/api/interface'
import { postPersonPublishTemplate } from '~/api/module/xihe'
import { useDetector } from '~/hooks/useDetector'

const userInfo = useUserInfo()
const { $t } = useNuxtApp()
const { isRightTaste } = useDetector()

const loading = ref(false)
const props = defineProps<{ data: any; scene: 'personal' | 'team' }>()

const emits = defineEmits(['close'])

interface FormState {
  name: string
  message: string
  grant: boolean
  cover_oss_path: string
  preview_video_cut_info?: any
  copyright_limited: string
  generate_record_xihe_task_id: string
  custom_preview_video_path?: string
  tags?: string[]
}

const formState = reactive<FormState>({
  name: props.data?.title || '',
  message: '',
  cover_oss_path: props.data.cover,
  generate_record_xihe_task_id: '',
  custom_preview_video_path: '',
  preview_video_cut_info: { start_time: 0, end_time: 10 },
  copyright_limited: 'False',
  grant: true,
})

const centerTags = useCenterTags()
const treeData: ComputedRef<TreeSelectProps['treeData']> = computed(() => {
  function transform(node: Tag) {
    const tmp: BaseOptionType = {}
    if (node.children) {
      tmp.children = node.children!.map((v) => transform(v))
    }
    tmp.label = node.tag_name
    tmp.value = node.ids
    return tmp
  }

  return centerTags.value.tags!.map((v) => transform(v))
})

const handleClose = () => {
  emits('close')
}

function formatTags(tags: string[]) {
  const map: any = {}

  function flatten(children: any[]) {
    if (!children) {
      return []
    }
    return (children || []).forEach((item) => {
      map[item.value] = item.children?.map((v: any) => v.value)
      flatten(item.children)
    })
  }

  flatten(treeData.value as any)

  const tagObj = {}

  function collect(tags: string[]) {
    tags.forEach((tag) => {
      if (map[tag] && map[tag].length > 0) {
        collect(map[tag])
      } else {
        const path = tag
          .split(':')
          .map((v) => v.split(',')[1])
          .join('.')
        setWith(tagObj, `${path}.weight`, 1, Object)
      }
    })
    return tagObj
  }

  collect(tags)

  return tagObj
}

const resourceLocation = injectResourceLocation()

const handleFinish = async () => {
  loading.value = true
  try {
    trackEvent(TRACK_EVENT.CLICK_PUBLISH_TO_YOUYAN_PLATFORM_APPLY, {
      source: resourceLocation?.source,
      ev_name: props.data.name,
      ev_id: props.data.id,
    })

    await postPersonPublishTemplate({
      name: formState.name,
      message: formState.message,
      tags: formatTags(formState.tags || []),
      custom_preview_video_path: formState.custom_preview_video_path,
      cover_oss_path: new URL(formState.cover_oss_path).pathname.slice(1), // 去掉 /
      preview_video_cut_info: formState.preview_video_cut_info,
      copyright_limited: formState.copyright_limited,
      generate_record_xihe_task_id:
        props.data.generate_record_task_id ||
        props.data.processing_xihe_task_info.generate_record_task_id,
    })
    usePublishSuccess()
    emits('close')
  } catch (err) {
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.item-grant {
  display: flex;
  align-items: center;
  .name {
    margin-right: 4px;
  }
  .none-grant {
    cursor: pointer;
    padding: 2px 6px;
    background-color: #d5faef;
    color: #0eb794;
    border-radius: 4px;
  }
  .personal-grant {
    cursor: pointer;
    padding: 2px 6px;
    background-color: #d5faef;
    color: #0eb794;
    border-radius: 4px;
  }
  .team-grant {
    cursor: pointer;
    padding: 2px 6px;
    background-color: #f1e2ff;
    color: #b972ff;
    border-radius: 4px;
  }
  .avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 4px;
  }
}
.icon-close {
  position: absolute;
  display: block;
  font-size: 16px;
  right: 18px;
  top: 14px;
  opacity: 0.3;
  cursor: pointer;
}
.title {
  position: relative;
  display: flex;
  height: 46px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-1);
}
.content {
  padding: 23px 55px;
}
.full-form-item {
  font-size: 14px;
  width: 100%;
  color: var(--text-1-70);
  padding-left: 10px;
}

.tip-title {
  width: 100%;
  margin-bottom: 10px;
}
.tip-rules {
  padding: 8px 12px;
  width: 100%;
  background: var(--back-2);
  border-radius: 8px;
  border: 1px solid var(--back-5);
  p,
  h3 {
    margin: 5px auto;
  }
  p {
    margin-left: 15px;
  }
}
.footer {
  display: flex;
  justify-content: center;
  padding: 16px 0;
  gap: 16px;
}
</style>
